/**
 * Converts any YouTube URL to the embed format required for iframes.
 * Also fixes YouTube Error 153 (Video player configuration error) by using correct URL format.
 */
export function getYouTubeEmbedUrl(url) {
  if (!url || typeof url !== 'string') return url;

  let videoId = null;

  // youtube.com/watch?v=VIDEO_ID, youtube.com/embed/VIDEO_ID, or youtube-nocookie.com/embed/VIDEO_ID
  const embedMatch = url.match(/(?:youtube(?:-nocookie)?\.com\/(?:watch\?v=|embed\/))([a-zA-Z0-9_-]{11})/);
  if (embedMatch) videoId = embedMatch[1];

  // youtu.be/VIDEO_ID
  const shortMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
  if (shortMatch) videoId = shortMatch[1];

  if (!videoId) return url;

  // Use youtube-nocookie.com for privacy + fixes Error 153 (referrer policy compatibility)
  return `https://www.youtube-nocookie.com/embed/${videoId}?rel=0`;
}
